<ion-grid class="login-page">
  <ion-row class="login-page__container">
    <ion-col size="12" sizeMd="6">
      @if (firstLoad) {
      <ion-card class="login-card" [ngStyle]="{ 'display': firstLoad ? 'block' : 'none' }">
        <ion-card-header class="login-card__header">
          <ion-card-title class="login-card__title">
            {{ "login.title" | translate }}
            <!-- <p class="login-card__logo logo-styled"><strong [innerHTML]="'header.title' | translate"></strong></p> -->
             <img
            src="/assets/images/MyGlobalRiskRGB_Positivo_new.svg"
            alt=""
            class="login-card__title__logo"
          />
          </ion-card-title>
          <ion-card-subtitle class="login-card__subtitle">
            {{ "login.subtitle" | translate }}</ion-card-subtitle
          >
          <ion-item-divider></ion-item-divider>
        </ion-card-header>

        <ion-card-content class="login-card__content">
          <app-general-error [code]="errorMess" />
          <form class="login-form" [formGroup]="loginForm" novalidate (submit)="submitloginForm()">
            <app-input
              [formGroup]="loginForm"
              label="login.email"
              formControlName="username"
              maxlength="55"
              [type]="userInt ? 'text' : 'email'"
              [required]="true"
              [doFocus]="shouldFocusUsername"
            ></app-input>

            @if(!this.userInt) {
            <div class="password-field-wrapper">
              <app-input
                [formGroup]="loginForm"
                label="login.password"
                formControlName="password"
                minlength="8"
                [type]="passwordType"
                [required]="true"
              ></app-input>
              @if(loginForm.get('password')?.value) {
                    <span
                      class="password-toggle-icon"
                      (click)="togglePasswordVisibility()"
                    >
                      <i class="icon" [ngClass]="showPassword ? 'icon-VIEW' : 'icon-NO-VIEW'"></i>
                    </span>
                  }
            </div>

            <div class="login-form__recover-password">
              <a (click)="handleRedirectForgotPass()"
                >{{ "login.forget-password" | translate }}
                <span
                  class="icon icon-SMALL-ARROW-RIGHT form-field__input-icon"
                ></span>
              </a>
            </div>
          }
            <div class="login-form__buttons">
              <ion-button
                class="button-block-mobile loginButton m-0"
                expand="block"
                type="submit"
                [disabled]="!loginForm.valid"
                >{{ "login.action-send" | translate }}</ion-button
              >
            </div>
          </form>
          <ion-item-divider></ion-item-divider>

          @if(!this.userInt) {

            <div class="login-form__button-register">
              <a (click)="handleRedirect()"
                >{{ "login.action-reg" | translate }}
              </a>
            </div>
          }
        </ion-card-content>
      </ion-card>
    }
    </ion-col>
    <ion-col sizeMd="6" class="login-page__header">
      <div>
        <header class="login-page__header-content">
          <h1 class="login-page__title">
            {{ "login.welcome-prefix" | translate }}
          </h1>
          <!-- ! CAMBIAR LOGO POR EL CORRESPONDIENTE -->
          <img
            src="/assets/images/MyGlobalRiskRGB_Positivo_new.svg"
            alt=""
            class="login-page__logo"
          />
        </header>
      </div>
    </ion-col>
  </ion-row>

  <div class="login-page__background">
    <video #loginVideo
      class="login-page__background-video"
      muted
      autoplay
      loop
      playsInline
      poster="/assets/vdeos/login/MapfreLoadingpagebackgroundvideoSmall.jpg"
    >
      <source
        src="/assets/vdeos/login/VideoLoginNew.mp4"
        type="video/mp4"
      />
    </video>

  </div>
</ion-grid>
